import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-page',
  templateUrl: './import-page.component.html',
  styleUrls: ['./import-page.component.css'],
})
export class ImportPageComponent implements OnInit {
  protected filterParams: string;

  constructor() {}

  ngOnInit() {}

  public setFilterParams(params) {
    this.filterParams = params;
  }
}



// WEBPACK FOOTER //
// ./src/app/import/import-page/import-page.component.ts